import ActiveNewsletters from "@/components/newsletter/ActiveNewsletters.vue";
import ContentBlock from "@/components/content-block";
import dynamicLocalization from "@/mixins/dynamic-localization";
import objToDate from "@/mixins/obj-to-date";
import LETTER from "@/data/letter.yml";
import MY_FIRST_PARTY from "@/data/my-first-party.yml";
const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);

export default {
  components: {
    ActiveNewsletters,
    ContentBlock,
  },
  mixins: [dynamicLocalization, objToDate],
  data() {
    const ticketSaleStartDate = this.objToDate(TICKET_SALE_START);
    const now = new Date();

    return {
      soldOut:
        ticketSaleStartDate <= now &&
        process.env.VUE_APP_TICKETS_AVAILABLE !== "true",
      partyDate: JSON.parse(process.env.VUE_APP_PARTY_DATE),
      LETTER,
      MY_FIRST_PARTY,
    };
  },
};
